import React, { useRef } from "react"
import { useSVGMount } from "./hooks/useSVGMount"
import { useHotspotListeners } from "./hooks/useHotspotListeners"
import { useHotspotHighlight } from "./hooks/useHotspotHighlight"
import { svgContainerStyle } from "./styles"

type SVGViewerProps = {
	svgUrl: string
	onSelectHotspot: (partNumber: string) => void
	selectedPartNumber: string
}

export const SVGViewer: React.FC<SVGViewerProps> = ({
	svgUrl,
	onSelectHotspot,
	selectedPartNumber,
}: SVGViewerProps) => {
	const containerRef = useRef<HTMLDivElement>(null)

	const { status, error } = useSVGMount(svgUrl, containerRef)
	useHotspotListeners(containerRef, onSelectHotspot)
	useHotspotHighlight(containerRef, selectedPartNumber)

	return (
		<div css={svgContainerStyle}>
			{status === "error" && <p>Error: {error?.message}</p>}
			<div ref={containerRef} className="svg-container" />
		</div>
	)
}
